// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__jzmpb","overlay":"Avatar_overlay__in+iA"};